import { render, staticRenderFns } from "./AdvertisingCardVertical.vue?vue&type=template&id=28e0b30c&scoped=true"
import script from "./AdvertisingCardVertical.vue?vue&type=script&lang=js"
export * from "./AdvertisingCardVertical.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingCardVertical.vue?vue&type=style&index=0&id=28e0b30c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0b30c",
  null
  
)

export default component.exports